import React, { useEffect, useState } from "react";
import DashboardHeader from "../../../components/header/DashboardHeader";
import { Link, useNavigate, useParams } from "react-router-dom";
import "../Overview/OverwiewDetail.scss";
import { avatar, dummyCard, upload_cover } from "../../../assets";
import { FaArrowRight, FaRegCommentDots } from "react-icons/fa6";
import { RiShareForwardLine } from "react-icons/ri";
import { feedDetailApi, feedReactionApi } from "../../../services/feeds";
import moment from "moment";
import { reactions } from "../../../utils/staticData";
import { toastMessage } from "../../../utils/toastMessage";
import OverviewComment from "./section/OverviewComment";
import { handleCopy } from "../../../utils/copyClipboard";
import { Dropdown } from "react-bootstrap";
import { HiDotsVertical } from "react-icons/hi";
import OverviewReport from "./section/OverviewReport";
import Slider from "react-slick";
import { FaArrowLeft } from "react-icons/fa";
import DeleteFeed from "./section/DeleteFeed";
import { useSelector } from "react-redux";
import { overViewDetailsLink } from "../../../utils/shareLink";
import { BiDotsVerticalRounded } from "react-icons/bi";
import { BsThreeDots } from "react-icons/bs";

const OverviewDetail = () => {
  const { id } = useParams();
  const [commentModal, setCommentModal] = useState(false);
  const [commentCount, setCommentCount] = useState("");
  const [reportModal, setReportModal] = useState(false);
  const [overviewDetails, setOverviewDetails] = useState({});
  const [deleteModal, setDeleteModal] = useState(false);
  const navigate = useNavigate();
  const { showAuth } = useSelector((state) => state?.showAuth);
  // ---------handle-commit------------
  const handleComment = () => {
    setCommentModal(true);
  };
  // ---------handle-commit------------
  const handleReport = () => {
    setReportModal(true);
  };
  // ---------handle-Delete------------
  const handleDelete = (data) => {
    setDeleteModal(true);
  };
  // ---------navigate-Handler-group-details-----------
  const navigateHandler = (id) => {
    navigate(`/dashboard/group/detail/${id}`);
  };
  // -----------handle-reaction-API---------------------
  const handleFeedsReaction = async (reaction, id) => {
    try {
      const { data } = await feedReactionApi({ _feed: id, reaction });
      const { success, message } = data;
      if (success) {
        getOverviewDetail();
      } else {
        toastMessage(
          message,
          success ? "success" : "error",
          "handleFeedsReaction"
        );
      }
    } catch (e) {
      console.error(e.message);
    }
  };
  //----------feed-details-api---------------
  const getOverviewDetail = async () => {
    try {
      const { data } = await feedDetailApi({ _id: id });
      const { success, message, data: response } = data;
      if (success) {
        setOverviewDetails(response || {});
      } else {
        toastMessage(message, "error", "overViewDetails");
      }
    } catch (e) {
      console.error("Error:-", e.message);
    }
  };
  useEffect(() => {
    getOverviewDetail();
  }, [id]);
  var settings = {
    autoplay: true,
    autoplaySpeed: 3000,
    dots: true,
    infinite: false,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };
  return (
    <>
      <DashboardHeader title={"Overview-Detail"} />
      <div className="dashboard_pages">
        <div className="over_view_detail">
          <div className="overview_header">
            <nav className="breadcrumb_wrap">
              <ul>
                <li>
                  <Link to={-1}>
                    <FaArrowLeft />
                  </Link>
                </li>
                <li>
                  <span>Post Details</span>
                </li>
              </ul>
            </nav>
          </div>

          <div className="economy">
            <span>{overviewDetails?._group?.categoryName || "N/A"}</span>
          </div>

          <div className="detail_page over_view_detail_heading">
            <h5 className="detail_title">{overviewDetails?.title || "N/A"}</h5>
            <div className="posted_by">
              <p>
                Posted by{" "}
                <b>
                  {overviewDetails?._group?.settings?.anonymousPosting
                    ? "Anonymous"
                    : overviewDetails?.createdBy?.fullName || "N/A"}
                </b>{" "}
                <span>{moment(overviewDetails?.createdAt).fromNow()}</span>
              </p>

              <Dropdown className="overview_detail_dropdown custom_dropdown">
                <Dropdown.Toggle id="dropdown-basic">
                  {/* <HiDotsVertical  /> */}
                  <BsThreeDots />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {overviewDetails?.createdBy?._id === showAuth?._id ? (
                    <>
                      <Dropdown.Item
                        as={Link}
                        to={`/dashboard/feed/edit-feed/${overviewDetails?._id}`}
                      >
                        Edit
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => handleDelete(overviewDetails)}
                      >
                        Delete
                      </Dropdown.Item>
                    </>
                  ) : (
                    <Dropdown.Item
                      onClick={() => handleReport(overviewDetails)}
                    >
                      Report
                    </Dropdown.Item>
                  )}
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div className="overview_detail_img">
              <div className="upload_cover">
                <div className="slider_banner">
                  <Slider {...settings}>
                    {overviewDetails?.attachments &&
                    overviewDetails?.attachments?.length > 0 ? (
                      overviewDetails?.attachments?.map((data, ind) => (
                        <div key={ind} className="upload_design_content">
                          {data.type === "VIDEO" ? (
                            <video
                              controls
                              width="100%"
                              poster={data.thumbnailUrl}
                            >
                              <source src={data.url} type="video/mp4" />
                              Your browser does not support the video tag.
                            </video>
                          ) : (
                            <img src={data.url} alt="attachment" />
                          )}
                        </div>
                      ))
                    ) : (
                      <div className="upload_design_content">
                        <img src={dummyCard} alt="attachment" />
                      </div>
                    )}
                  </Slider>
                </div>
              </div>
            </div>

            <div className="grp_name_contener">
              {/* <Link to={`/dashboard/group/detail/${overviewDetails?._group?._id}`}> */}
              <div className="grp_name">
                {/* <img src={overviewDetails?.createdBy?.profilePicture || avatar} /> */}
                <img src={overviewDetails?._group?.coverImage || avatar} />

                <p
                  onClick={() => navigateHandler(overviewDetails?._group?._id)}
                >
                  <span>Group name</span>
                  <b>{overviewDetails?._group?.name || "N/A"}</b>
                </p>
              </div>
              <span
                onClick={() => navigateHandler(overviewDetails?._group?._id)}
              >
                <FaArrowRight />
              </span>
              {/* </Link> */}
            </div>

            <div className="card_footer">
              <div className="card_footer_like_share">
                <button className="card_footer_btn">
                  {reactions?.map((data, ind) => (
                    <span
                      key={ind}
                      className="me-2 emojireaction"
                      onClick={() =>
                        handleFeedsReaction(data?.name, overviewDetails?._id)
                      }
                    >
                      {overviewDetails?.myReaction?.[data?.name]
                        ? data?.fillEmoji
                        : data?.emoji}
                      {overviewDetails?.reactions?.[data?.name] || ""}
                    </span>
                  ))}
                </button>
                <button
                  className="card_footer_btn_two"
                  onClick={() => handleComment()}
                >
                  <FaRegCommentDots />
                  {/* <BiDotsVerticalRounde /> */}
                  <span> {commentCount || ""} </span> Comments
                </button>
              </div>
              <button
                className="card_footer_btn"
                onClick={() =>
                  handleCopy(`${overViewDetailsLink}${overviewDetails?._id}`)
                }
              >
                <RiShareForwardLine />
                <span>{overviewDetails?.shareCount || ""}</span> Share
              </button>
            </div>

            <div className="traveling_text">
              <p>{overviewDetails?.description || "N/A"}</p>
            </div>
          </div>
        </div>
      </div>
      {/* ---------comments--------------------- */}
      <OverviewComment
        show={commentModal}
        close={() => setCommentModal(false)}
        selectedData={overviewDetails}
        setCommentCount={setCommentCount}
        pageName={"Post"}
      />
      {/* ---------report--------------------- */}
      <OverviewReport
        show={reportModal}
        close={() => setReportModal(false)}
        selectedData={overviewDetails}
      />
      {/* //-----------feed-request----------------- */}
      {deleteModal && (
        <DeleteFeed
          show={deleteModal}
          close={() => setDeleteModal(false)}
          scroll={false}
          navigate={true}
          listing={getOverviewDetail}
          id={overviewDetails?._id}
          feedName={overviewDetails?._group?.name}
          // setPage={setPage}
          // setHasMore={setHasMore}
        />
      )}
    </>
  );
};

export default OverviewDetail;
